import { DatePicker } from '@material-ui/pickers'
import { fetchPaymentList } from 'src/pages/Payment/redux/list'
import { Form, Field, FormSpy } from 'react-final-form'
import { Link as RouterLink } from 'react-router-dom'
import { setPage } from 'src/features/Utils/mutators'
import { useSelector, useDispatch } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Chip from 'src/pages/Payment/List/Chip.js'
import CommaPrice from 'src/features/Utils/CommaPrice'
import get from 'lodash/get'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import Layout from 'src/features/Layout'
import MenuItem from '@material-ui/core/MenuItem'
import moment from 'moment'
import Pagination from '@material-ui/lab/Pagination'
import Paper from '@material-ui/core/Paper'
import React, { useState, Fragment, useEffect } from 'react'
import SearchIcon from '@material-ui/icons/Search'
import Skeleton from '@material-ui/lab/Skeleton'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableHeadCell from 'src/pages/Payment/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TextField from '@material-ui/core/TextField'
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat'
import Typography from '@material-ui/core/Typography'
import InvoiceModal from './InvoiceModal'

const INITIAL_FORM = {
  order_no: '',
  store_name: '',
  start_date: null,
  end_date: null,
  status: '',
  page: 1,
  limit: 10,
}

const PAYMENT_STATUS = [
  {
    text: 'All',
    value: '',
  },
  {
    text: 'Wait',
    value: 'wait',
  },
  {
    text: 'Ready',
    value: 'ready',
  },
  {
    text: 'Paid',
    value: 'paid',
  },
  {
    text: 'Bad Debt',
    value: 'bad_debt',
  },
  {
    text: 'Cancel',
    value: 'cancel',
  },
]

const FAKE_LOADING = [1, 2, 3, 4, 5, 6]

const SearchButton = withStyles((theme) => ({
  root: {
    borderRadius: theme.spacing(5),
  },
}))(Button)

function transformQuery(payload) {
  let response = {}
  const slug = get(payload, 'order_no', '')
  const mall_name = get(payload, 'store_name', '')
  const start_date = get(payload, 'start_date', null)
  const end_date = get(payload, 'end_date', null)
  const payment_status = get(payload, 'status', '')
  const page = get(payload, 'page', 1)
  const limit = get(payload, 'limit', 10)

  if (slug !== '') {
    response = { ...response, slug }
  }

  if (mall_name !== '') {
    response = { ...response, mall_name }
  }

  if (start_date !== null) {
    response = { ...response, start_date }
  }

  if (end_date !== null) {
    response = { ...response, end_date }
  }

  if (payment_status !== '') {
    response = { ...response, payment_status }
  }

  response = { ...response, page, limit }

  return response
}

function PaymentList() {
  const dispatch = useDispatch()
  const fetching = useSelector((state) => state.payment.list.fetching)
  const error = useSelector((state) => state.payment.list.error)
  const data = useSelector((state) => state.payment.list.data)
  const total = useSelector((state) => state.payment.list.total)

  const [openInvoceModal, setOpenInvoiceModal] = useState(false)
  const handleToggleInvoice = () => {
    setOpenInvoiceModal(!openInvoceModal)
  }

  const handleFetchList = (values = INITIAL_FORM) => {
    const query = transformQuery(values)
    dispatch(fetchPaymentList(query))
  }

  useEffect(() => {
    dispatch(fetchPaymentList())
  }, [dispatch])

  let content

  if (fetching) {
    content = FAKE_LOADING.map((value) => (
      <TableRow key={value}>
        <TableCell component="th" scope="row">
          <Skeleton animation="wave" />
        </TableCell>
        <TableCell>
          <Skeleton animation="wave" />
        </TableCell>
        <TableCell>
          <Skeleton animation="wave" />
        </TableCell>
        <TableCell>
          <Skeleton animation="wave" />
        </TableCell>
        <TableCell>
          <Skeleton animation="wave" />
        </TableCell>
        <TableCell>
          <Skeleton animation="wave" />
        </TableCell>
        <TableCell>
          <Skeleton animation="wave" />
        </TableCell>
      </TableRow>
    ))
  } else if (error) {
    content = (
      <TableRow>
        <TableCell align="center" colSpan={6}>
          {error}
        </TableCell>
      </TableRow>
    )
  } else {
    content = data.map((row) => {
      const limit_check = get(row, 'payment_timestamp.limit', '-') === '-'
      const limit_date = limit_check ? '-' : moment(get(row, 'payment_timestamp.limit')).format('DD/MM/YYYY')
      return (
        <TableRow key={row._id}>
          <TableCell component="th" scope="row">
            <Chip status={row.payment_status} title={row.payment_status} />
          </TableCell>
          <TableCell>{row.account.mall.name}</TableCell>
          <TableCell>{CommaPrice(row.price.total)}</TableCell>
          <TableCell>{limit_date}</TableCell>
          <TableCell>{`${row.account.first_name} ${row.account.last_name}`}</TableCell>
          <TableCell>{row.account.mobile}</TableCell>
          <TableCell>
            <IconButton
              target="_blank"
              component={RouterLink}
              to={`/payment/${row._id}`}
              size="small"
              aria-label={`action-${row._id}`}
            >
              <TrendingFlatIcon />
            </IconButton>
          </TableCell>
        </TableRow>
      )
    })
  }

  return (
    <Layout>
      <InvoiceModal open={openInvoceModal} onClose={handleToggleInvoice} />
      <Box component={Paper} p={2}>
        <Form
          initialValues={INITIAL_FORM}
          onSubmit={({ page, limit, ...values }, { mutators }) => {
            mutators.setPage(1)
            handleFetchList({ ...values, limit, page: 1 })
          }}
          mutators={{ setPage }}
          subscription={{ submitting: true }}
        >
          {({ handleSubmit, submitting }) => (
            <Fragment>
              <Box component="form" onSubmit={handleSubmit} noValidate autoComplete="off">
                <Typography variant="h5" gutterBottom>
                  Payment
                </Typography>
                <Box my={2}>
                  <Grid container spacing={1} alignItems="center">
                    <Grid item xs={6}>
                      <Field name="order_no">
                        {(props) => (
                          <TextField
                            label="Search by Order Number"
                            name={props.input.name}
                            value={props.input.value}
                            onChange={props.input.onChange}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchIcon />
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                            size="small"
                            fullWidth
                          />
                        )}
                      </Field>
                    </Grid>
                    <Grid item xs={6}>
                      <Field name="store_name">
                        {(props) => (
                          <TextField
                            label="Search by Store Name"
                            name={props.input.name}
                            value={props.input.value}
                            onChange={props.input.onChange}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchIcon />
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                            size="small"
                            fullWidth
                          />
                        )}
                      </Field>
                    </Grid>
                  </Grid>
                </Box>
                <Box my={2}>
                  <Grid container spacing={1} alignItems="center">
                    <Grid item xs={3}>
                      <Field name="start_date" allowNull>
                        {(props) => (
                          <DatePicker
                            name={props.input.name}
                            value={props.input.value}
                            onChange={props.input.onChange}
                            placeholder="Select"
                            openTo="year"
                            format="dd/MM/yyyy"
                            label="Start Date"
                            views={['year', 'month', 'date']}
                            inputVariant="outlined"
                            size="small"
                            invalidDateMessage={null}
                            fullWidth
                            disableFuture
                            autoOk
                            clearable
                          />
                        )}
                      </Field>
                    </Grid>
                    <Grid item xs={3}>
                      <Field name="end_date" allowNull>
                        {(props) => (
                          <DatePicker
                            name={props.input.name}
                            value={props.input.value}
                            onChange={props.input.onChange}
                            placeholder="Select"
                            openTo="year"
                            format="dd/MM/yyyy"
                            label="End Date"
                            views={['year', 'month', 'date']}
                            inputVariant="outlined"
                            size="small"
                            invalidDateMessage={null}
                            fullWidth
                            disableFuture
                            autoOk
                            clearable
                          />
                        )}
                      </Field>
                    </Grid>
                    <Grid item xs={3}>
                      <Field name="status">
                        {(props) => (
                          <TextField
                            id="outlined-status-picker"
                            label="Select"
                            variant="outlined"
                            name={props.input.name}
                            value={props.input.value}
                            onChange={props.input.onChange}
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            SelectProps={{ displayEmpty: true }}
                            select
                            fullWidth
                          >
                            {PAYMENT_STATUS.map(({ text, value }, idx) => (
                              <MenuItem key={value} value={value}>
                                {idx === 0 ? <em>{text}</em> : text}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                      </Field>
                    </Grid>
                    <Grid item xs={3}>
                      <SearchButton variant="contained" color="secondary" type="submit" disabled={fetching}>
                        SEARCH
                      </SearchButton>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Box mt={2}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Typography variant="caption" display="block">
                    Result found {total} Order(s)
                  </Typography>
                  <Button color="primary" variant="contained" onClick={handleToggleInvoice}>
                    INVOICE
                  </Button>
                </Box>

                <TableContainer component={Paper} elevation={0}>
                  <Table aria-label="payment-list-table">
                    <TableHead>
                      <TableRow>
                        <TableHeadCell>STATUS</TableHeadCell>
                        <TableHeadCell>STORE NAME</TableHeadCell>
                        <TableHeadCell>TOTAL PRICE</TableHeadCell>
                        <TableHeadCell>DUE DATE</TableHeadCell>
                        <TableHeadCell>CONTACT</TableHeadCell>
                        <TableHeadCell>PHONE NUMBER</TableHeadCell>
                        <TableHeadCell></TableHeadCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>{content}</TableBody>
                  </Table>
                </TableContainer>
              </Box>
              <Box display="flex" justifyContent="flex-end" mt={2}>
                <FormSpy>
                  {({ values, form: { mutators } }) => (
                    <Pagination
                      count={Math.ceil(total / values.limit)}
                      page={values.page}
                      onChange={(e, page) => {
                        mutators.setPage(page)
                        handleFetchList({ ...values, limit: values.limit, page })
                      }}
                      color="primary"
                    />
                  )}
                </FormSpy>
              </Box>
            </Fragment>
          )}
        </Form>
      </Box>
    </Layout>
  )
}

export default PaymentList
